<template>
    <span v-cloak>
        <v-chip v-if="InDevelopment"
                label
                color="orange darken-2"
                text-color="white"
                style="margin-left:8px;">
            <v-icon left>fa fa-flask</v-icon>
            Test Version
        </v-chip>
        <v-chip v-if="IsBetaUITester"
                label
                color="orange darken-2"
                text-color="white"
                style="margin-left:8px;">
            <v-icon left>fa fa-flask</v-icon>
            Beta UI Tester
        </v-chip>
    </span>
</template>

<script>
    import appApiMixin from '@/views/components/mixins/appApi.js'
    import globalMixin from '@/views/components/mixins/base/global.js'

    export default {
        mixins: [
            appApiMixin,
            globalMixin,
        ],
        data() {
            return {
                appSettings: {},
            }
        },
        computed: {
            IsBetaUITester() { return this.appSettings?.betaUITesting === true; },
        },
        mounted() {
            this.LoadAppSettings();
        }
    }
</script>